import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
} from '@mui/material';
import moment from 'moment';
import 'moment/locale/fr';
import Footer from '../navbar/Footer';

moment.locale('fr');

const bulletins = [
    {
        title: "Population par sexe et par collines en 2008",
        description: "Ce rapport offre une analyse approfondie des dynamiques démographiques locales sur les données détaillées de la population par sexe et par collines pour l'année 2008.",
        link: "/documents/PropDemographiques/Population-par-sexe-et-par-collines-en-2008.pdf",
        publicationDate: "2008-01-01",
    },
    {
        title: "Population par sexe et par provinces en 2008",
        description: "L'analyse approfondie des dynamiques démographiques locales sur les données détaillées de la population par sexe et par province pour l'année 2008.",
        link: "/documents/PropDemographiques/Population-par-sexe-et-par-provinces-en-2008.pdf",
        publicationDate: "2008-01-01",
    },
    {
        title: "Projections démographiques au niveau communal 2010-2050",
        description: "Les projections démographiques détaillées pour chaque commune, s'étendant de 2010 à 2050.",
        link: "/documents/PropDemographiques/PROJECTIONS-COMMUNALES-020620-rapport-VF.pdf",
        publicationDate: "2020-06-02",
    },
    {
        title: "Projections démographiques 2010-2050 niveau national et provincial",
        description: "Les projections démographiques globales pour le Burundi, avec une ventilation au niveau national et provincial, couvrant la période 2010-2050.",
        link: "/documents/PropDemographiques/Projections-démographiques-2010-2050.pdf",
        publicationDate: "2022-02-20",
    },
    {
        title: "Population par sexe et par communes en 2008",
        description: "Les données démographiques ventilées par sexe et par commune pour l'année 2008. Un outil précieux pour les analyses locales et la planification.",
        link: "/documents/PropDemographiques/Population-par-sexe-et-par-communes-en-2008.pdf",
        publicationDate: "2008-01-01",
    }
];

function PropDemographique() {
    const [filterDate, setFilterDate] = useState('');
    const [visibleBulletins, setVisibleBulletins] = useState(2);

    const availableYears = [...new Set(bulletins.map(bulletin => moment(bulletin.publicationDate).format('YYYY')))];

    const filteredBulletins = filterDate
        ? bulletins.filter(bulletin => moment(bulletin.publicationDate).isSame(filterDate, 'year'))
        : bulletins;

    const handleDateChange = (event) => {
        setFilterDate(event.target.value);
        setVisibleBulletins(4); 
    };

    const handleShowMore = () => {
        setVisibleBulletins(prevVisibleBulletins => prevVisibleBulletins + 2);
    };

    const displayedBulletins = filteredBulletins.slice(0, visibleBulletins);

    const hasMoreBulletins = displayedBulletins.length < filteredBulletins.length;

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
            <NavigationBar />
            <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
                <Typography variant="h4" align="justify" gutterBottom style={{ color: '#4CAF50' }}>
                    Projections démographiques du Burundi
                </Typography>
                <Typography variant="body1" align="justify" paragraph>
                    Cette section présente les projections démographiques constituant un outil fondamental pour anticiper l’évolution de la population burundaise.
                </Typography>

                <FormControl variant="outlined" style={{ width: '100%', marginBottom: '20px' }}>
                    <InputLabel id="year-select-label">Filtrer par année</InputLabel>
                    <Select
                        labelId="year-select-label"
                        id="year-select"
                        value={filterDate}
                        onChange={handleDateChange}
                        label="Filtrer par année"
                    >
                        <MenuItem value="">
                            <em>Toutes les années</em>
                        </MenuItem>
                        {availableYears.sort().map(year => (
                            <MenuItem key={year} value={year}>{year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Grid container spacing={1} style={{ marginTop: '5px' }}>
                    {displayedBulletins.map((bulletin, index) => (
                        <Grid item xs={12} sm={6} md={12} key={index}>
                            <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
                                <CardContent>
                                    <Box display="flex" alignItems="flex-start">
                                        <Box width="30%" marginRight="16px">
                                            <a href={bulletin.link} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src="/asset/cover/cover.jpg"
                                                    alt="Couverture"
                                                    style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                                                />
                                            </a>
                                        </Box>
                                        <Box width="70%">
                                            <a href={bulletin.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                                <Typography variant="h6" component="div"  style={{ fontWeight: 'bold', color: '#388E3C', marginBottom: '8px' }}>
                                                {<DownloadIcon />} {bulletin.title.charAt(0).toUpperCase() + bulletin.title.slice(1).toLowerCase()}
                                                </Typography>
                                            </a>
                                            <Typography variant="body2" component="div">
                                                {bulletin.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                {hasMoreBulletins && (
                    <Box display="flex" justifyContent="left" mt={3}>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: '#4CAF50', color: 'white' }}
                            onClick={handleShowMore}
                        >
                            Plus de rapports
                        </Button>
                    </Box>
                )}
            </Container>
            <br />
            <br />
            <Footer />
        </div>
    );
}

export default PropDemographique;